import React from 'react';

function Footer() {
  return (
    <footer>
      <div className='footer-wrap'>
        <div className='footer-items-wrap'>
          <div className='footer-logo'>
            <a className='footer-logo__link' href='https://linforsakring.se'>
              <img src='logo_w_tagline.svg' alt='Lin försäkringar .' />
            </a>
          </div>
          <div className='footer-item'>
            <h3>Viktiga länkar</h3>

            <nav>
              <ul className='footer-nav'>
                <li>
                  <a
                    href='https://www.linforsakring.se/villkor'
                    className='menu-item menu-forsakringsvillkor'
                  >
                    Försäkringsvillkor
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.linforsakring.se/fki'
                    className='menu-item menu-forkopsinformation'
                  >
                    Förköpsinformation
                  </a>
                </li>
                <li>
                  <a
                    href='https://linforsakring.se/ipid'
                    className='menu-item menu-produktblad'
                  >
                    Produktblad
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.linforsakring.se/integritetspolicy'
                    className='menu-item menu-integritetspolicy'
                  >
                    Integritetspolicy
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.linforsakring.se/kontakt'
                    className='menu-item menu-klagomal'
                  >
                    Klagomål
                  </a>
                </li>
              </ul>
            </nav>
          </div>

          <div className='footer-item'>
            <h3>Om Lin</h3>

            <p>
              Lin försäkring är ett varumärke under Eir Försäkring. Eir står
              under tillsyn av Finansinspektionen och har sedan i juni 2019
              tillstånd att bedriva försäkringsrörelse i enlighet med
              Försäkringsrörelselagen. Tack vare att Eir är ett helt nytt
              försäkringsbolag kan vi redan från början bedriva kostnadseffektiv
              verksamhet på alla plan och på så sätt utmana den befintliga
              marknaden. Vi bygger hela vår verksamhet digitalt och erbjuder
              samma trygghet och försäkringsskydd som jämförbara och
              traditionella försäkringsbolag.
            </p>
          </div>
          <div className='copyline'>
            <div className='copy'>
              © 2020 Lin försäkringar.
              <div>
                <a
                  href='https://pigment.se/'
                  target='_blank'
                  title='Producerad av Pigment webbyrå'
                >
                  Pigment webbyrå
                </a>
              </div>
              <div className='eir-info'>
                <img
                  className='eir-info__logo'
                  src='/wp-content/uploads/2020/02/eir-logotype-black.png'
                  alt=''
                />

                <p className='eir-info__text'>
                  Försäkringsgivare:
                  <br />
                  Eir Försäkring AB, org. 559166-0617
                  <br />
                  Mäster Samuelsgatan 36
                  <br />
                  111 57 Stockholm, Sweden
                  <br />
                  <a href='mailto:info@eirforsakring.se'>
                    info@eirforsakring.se
                  </a>
                </p>
              </div>{' '}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
export default Footer;
